import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=56da94f5&scoped=true&"
import script from "./AddProfile.vue?vue&type=script&lang=js&"
export * from "./AddProfile.vue?vue&type=script&lang=js&"
import style0 from "./AddProfile.vue?vue&type=style&index=0&id=56da94f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da94f5",
  null
  
)

export default component.exports